import React from 'react';
import { Sparkles, Lightbulb, Rocket } from 'lucide-react';
import { MathJax } from 'better-react-mathjax';
import ReactMarkdown from 'react-markdown';

export default function ObjectiveCard({ competence }) {
  if (!competence) return null;

  return (
    <div className="mb-6 rounded-xl overflow-hidden shadow-lg border border-gray-200">
      {/* Header avec dégradé */}
      <div className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 p-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <Sparkles className="w-6 h-6 text-white animate-pulse" />
            <Lightbulb className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-white">
              Mon objectif 
            </h3>
          </div>
        </div>
      </div>

      {/* Contenu avec mise en forme améliorée */}
      <div className="p-6 bg-white">
        <div className="flex items-start gap-4">
          <Rocket className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
          <div className="prose max-w-none text-gray-700 leading-relaxed">
            <h4 className="text-lg font-medium text-indigo-600 mb-2">
              {competence.title}
            </h4>
            {competence.description && (
              <MathJax>
                <ReactMarkdown>{competence.description}</ReactMarkdown>
              </MathJax>
            )}
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-100">
          <p className="text-sm text-indigo-400 flex items-center gap-2">
            <Sparkles className="w-4 h-4" />
            Espace d'innovation et de recherche
          </p>
        </div>
      </div>
    </div>
  );
}